import React, { useEffect, useState } from 'react'
import WhatsappButton from '../tools/WhatsappButton'

const ProductModal = ({ pProduct, pWhatsAppDefaultText, pWhatsAppPhoneNumber, pShippingPrice }) => {
    const location = window.location.origin
    const [selectedImage, setSelectedImage] = useState("")

    useEffect(() => {
        console.log("88");
        if (pProduct) {
            setSelectedImage(pProduct.image)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pProduct])

    return (
        <div className="modal fade" id="staticBackdrop" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
            <div className="modal-dialog">
                {
                    pProduct ? (
                        <div className="modal-content">
                            <div className="modal-header">
                                <h1 className="modal-title fs-5" id="staticBackdropLabel">{pProduct.brand.name} {pProduct.name}</h1>
                                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                            </div>
                            <div className="modal-body">
                                <img style={{ width: "90%" }} src={selectedImage} alt={pProduct.name} />
                                <div className='row'>
                                    <div className="col-6" onClick={() => setSelectedImage(pProduct.image)}>
                                        <img style={{ width: "75%" }} src={pProduct.image} alt={pProduct.name} />
                                    </div>
                                    <div className="col-6" onClick={() => setSelectedImage(pProduct.image2)}>
                                        <img style={{ width: "75%" }} src={pProduct.image2} alt={pProduct.name} />
                                    </div>
                                </div>
                                <h3 className='text-start'>{pProduct.price > 0 ? "₡" + pProduct.price.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,') : "Cotizar"}</h3>
                                <p className='text-start'>Envío: ₡{parseFloat(pShippingPrice).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}</p>
                                <p className='text-start'>{pProduct.description}</p>
                                <p className='text-start'>Categorías: {pProduct.categories.map(item => item.name).join(", ")}</p>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">
                                    <i className="fa-regular fa-circle-xmark fa-lg"></i>
                                </button>
                                <WhatsappButton text={`${pWhatsAppDefaultText} ${pProduct.brand.name} ${pProduct.name} ${location}/Product/${pProduct.id}`} whatsAppPhoneNumber={pWhatsAppPhoneNumber} />
                            </div>
                        </div>
                    ) : (<></>)
                }
            </div>
        </div>
    )
}

export default ProductModal